export const VendorMenu = [
  {
    title: "Balloon Services",
    url: "/vendors/balloons",
    cName: "nav-links",
    category: "balloons",
  },
  {
    title: "Caterers",
    url: "/vendors/catering",
    cName: "nav-links",
    category: "catering",
  },

  {
    title: "Character Actors",
    url: "/vendors/party_characters",
    cName: "nav-links",
    category: "party_characters",
  },

  {
    title: "Clowns",
    url: "/vendors/party_clown",
    cName: "nav-links",
    category: "party_clown",
  },

  {
    title: "DJs",
    url: "/vendors/djs",
    cName: "nav-links",
    category: "djs",
  },

  {
    title: "Equipment Rentals",
    url: "/vendors/party_rental",
    cName: "nav-links",
    category: "party_rental",
  },

  {
    title: "Floral Designers",
    url: "/vendors/floral",
    cName: "nav-links",
    category: "floral",
  },

  {
    title: "Magicians",
    url: "/vendors/party_magician",
    cName: "nav-links",
    category: "party_magician",
  },
  {
    title: "Musicians",
    url: "/vendors/musicians",
    cName: "nav-links",
    category: "musicians",
  },

  {
    title: "Photographers",
    url: "/vendors/photographers",
    cName: "nav-links",
    category: "photographers",
  },

  {
    title: "Venues",
    url: "/vendors/venues",
    cName: "nav-links",
    category: "venues",
  },

  {
    title: "Videographers",
    url: "/vendors/videographers",
    cName: "nav-links",
    category: "videographers",
  },
];
